import { render, staticRenderFns } from "./MealPlanOverview.vue?vue&type=template&id=ddac21bc&scoped=true"
import script from "./MealPlanOverview.vue?vue&type=script&lang=js"
export * from "./MealPlanOverview.vue?vue&type=script&lang=js"
import style0 from "./MealPlanOverview.vue?vue&type=style&index=0&id=ddac21bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac21bc",
  null
  
)

export default component.exports